(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stride-launch-countdown')) {
    class StrideLaunchCountdown extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.fields = Object.fromEntries(
          [...this.querySelectorAll('[data-unit]')].map(node => [node.dataset.unit, node])
        );
        if (!Number.isFinite(this.deadline)) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-calendar-button]').addEventListener('click', () => this.saveCalendar(), options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          document.documentElement.style.setProperty(
            '--countdown-bar-height',
            this.visible ? Math.ceil(this.getBoundingClientRect().height) + 'px' : '0px'
          );
        });
        this.intersectionObserver.observe(this);
        this.resizeObserver = new ResizeObserver(entries => {
          if (this.visible) {
            document.documentElement.style.setProperty(
              '--countdown-bar-height',
              Math.ceil(entries[0].contentRect.height) + 'px'
            );
          }
        });
        this.resizeObserver.observe(this);
        this.start();
      }

      disconnectedCallback() {
        window.clearTimeout(this.tickTimer);
        this.controller?.abort();
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
      }

      start() {
        window.clearTimeout(this.tickTimer);
        if (document.hidden) return;
        this.update();
        if (Date.now() < this.deadline) {
          this.tickTimer = window.setTimeout(() => this.start(), 1000 - Date.now() % 1000);
        }
      }

      update(now = Date.now()) {
        const total = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total % 86400 / 3600),
          minutes: Math.floor(total % 3600 / 60),
          seconds: total % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          const node = this.fields[unit];
          const text = String(value).padStart(2, '0');
          if (node.textContent.trim() === text) continue;
          node.textContent = text;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            node.classList.add('is-changing');
            node.addEventListener('animationend', () => node.classList.remove('is-changing'), { once: true });
          }
        }
        if (total === 0 && this.dataset.expired !== 'true') {
          this.dataset.expired = 'true';
          this.querySelector('[data-launch-headline]').textContent = this.dataset.complete;
          this.querySelector('[data-calendar-button]').hidden = true;
          this.querySelector('[data-launch-shop]').hidden = false;
          this.querySelector('[data-launch-status]').textContent = this.dataset.complete;
        }
      }

      calendarContents() {
        const escape = value => String(value).replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
        const stamp = date => new Date(date).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
        const fold = line => {
          const lines = [];
          let current = '';
          let length = 0;
          for (const character of line) {
            const size = new TextEncoder().encode(character).length;
            if (length + size > 73) {
              lines.push(current);
              current = ' ' + character;
              length = 1 + size;
            } else {
              current += character;
              length += size;
            }
          }
          lines.push(current);
          return lines.join('\r\n');
        };
        return [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'PRODID:-//Stride Kicks//Launch//ES',
          'CALSCALE:GREGORIAN',
          'METHOD:PUBLISH',
          'BEGIN:VEVENT',
          'UID:stride-kicks-launch-' + this.deadline + '@stridekicks593.com',
          'DTSTAMP:' + stamp(Date.now()),
          'DTSTART:' + stamp(this.deadline),
          'DTEND:' + stamp(this.deadline + 30 * 60 * 1000),
          'SUMMARY:' + escape(this.dataset.eventTitle),
          'DESCRIPTION:' + escape(this.dataset.eventDescription),
          'URL:' + this.dataset.eventUrl,
          'END:VEVENT',
          'END:VCALENDAR',
          ''
        ].map(fold).join('\r\n');
      }

      saveCalendar() {
        const blob = new Blob([this.calendarContents()], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.dataset.calendarName;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.querySelector('[data-launch-status]').textContent = this.dataset.statusSaved;
      }
    }
    customElements.define('stride-launch-countdown', StrideLaunchCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBackgroundColorScheme = this.getAttribute('data-background-color-scheme') || 'color-background-1';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      // The bounds are measured once, so they have to be measured again when a
      // section above the header leaves the layout.
      this.refreshBoundsHandler = () => this.createObserver();
      //this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('announcement:closed', this.refreshBoundsHandler);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('announcement:closed', this.refreshBoundsHandler);
    }

    isOverlayHeader() {
      return this.header.dataset.headerOverlay === 'true';
    }

    shouldRestoreOverlay() {
      return this.isOverlayHeader() && this.header.dataset.headerHovered !== 'true';
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.onScroll();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop >= this.header.offsetHeight) {
          this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
          if (this.header.dataset.headerOverOverlay !== 'true') {
            this.header.classList.remove('color-background-2');
          }
        } else {
          this.header.classList.remove('shopify-section-header-sticky');
          if (this.shouldRestoreOverlay()) {
            this.header.classList.add('color-background-2');
          }
        }

        this.header.style.transition = 'background var(--duration-short)';
        this.header.style.transform = 'translateY(0)';
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.overflow-hidden-tablet')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.entering-section')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden', 'color-background-2');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.shouldRestoreOverlay()) {
        this.header.classList.add('color-background-2');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
      this.visibleMediaObserver = null;
      this.visibleMediaRatios = new Map();
      this.activeVisibleMedia = null;
    }

    hide() {
      this.teardownVisibleMediaAutoplay();
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.setupVisibleMediaAutoplay();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    isVideoAutoplayEnabled() {
      return this.dataset.enableVideoAutoplay === 'true';
    }

    setupVisibleMediaAutoplay() {
      this.teardownVisibleMediaAutoplay();

      if (!this.isVideoAutoplayEnabled()) return;

      const dialog = this.querySelector('.product-media-modal__dialog');
      const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__item')).filter((item) =>
        item.querySelector('deferred-media')
      );

      if (!dialog || !mediaItems.length) return;

      this.visibleMediaObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibleMediaRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });

          this.syncVisibleMediaPlayback();
        },
        {
          root: dialog,
          threshold: [0, 0.35, 0.6, 0.85],
        }
      );

      mediaItems.forEach((item) => {
        this.visibleMediaRatios.set(item, 0);
        this.visibleMediaObserver.observe(item);
      });

      requestAnimationFrame(() => this.syncVisibleMediaPlayback());
    }

    syncVisibleMediaPlayback() {
      if (!this.isVideoAutoplayEnabled()) return;

      let nextActiveMedia = null;
      let maxRatio = 0;

      this.visibleMediaRatios.forEach((ratio, item) => {
        if (ratio > maxRatio) {
          maxRatio = ratio;
          nextActiveMedia = item;
        }
      });

      if (maxRatio < 0.35) {
        nextActiveMedia = null;
      }

      if (this.activeVisibleMedia === nextActiveMedia) return;

      window.pauseAllMedia();
      this.activeVisibleMedia = nextActiveMedia;

      if (!nextActiveMedia) return;

      const deferredMedia = nextActiveMedia.querySelector('deferred-media');
      if (deferredMedia) {
        window.playMedia(deferredMedia);
      }
    }

    teardownVisibleMediaAutoplay() {
      this.visibleMediaObserver?.disconnect();
      this.visibleMediaObserver = null;
      this.visibleMediaRatios.clear();
      this.activeVisibleMedia = null;
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
